import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'Thankyou.ThankyouSummary.title',
    description: 'Order Summary title',
    defaultMessage: 'Order Number: {orderNumber}',
  },
  titlePrint: {
    id: 'Thankyou.ThankyouSummary.titlePrint',
    description: 'Order Summary title print label',
    defaultMessage: 'Print',
  },
  creditCard: {
    id: 'Thankyou.ThankyouSummary.creditCard',
    description: 'Credit Card Payment Method',
    defaultMessage: 'Credit Card',
  },
  cardLogoAltMessage: {
    id: 'Thankyou.ThankyouSummary.cardLogoAltMessage',
    description: 'Card logo alt message',
    defaultMessage: 'Credit Card Logo',
  },
  creditCardEndingIn: {
    id: 'Thankyou.ThankyouSummary.creditCardEndingIn',
    description: 'Credit Card Ending In Message',
    defaultMessage: 'Ending In',
  },
  creditCardExpiry: {
    id: 'Thankyou.ThankyouSummary.creditCardExpiry',
    description: 'Credit Card Expiry Date',
    defaultMessage: '{expMonth}/20{expYear}',
  },
  orderNumber: {
    id: 'Thankyou.ThankyouSummary.orderNumber',
    description: 'Order Summary Order Number label',
    defaultMessage: 'Order Number',
  },
  orderDate: {
    id: 'Thankyou.ThankyouSummary.orderDate',
    description: 'Order Summary Order Date label',
    defaultMessage: 'Order Date',
  },
  items: {
    id: 'Thankyou.ThankyouSummary.items',
    description: 'Order Summary Items label',
    defaultMessage: 'Items ( x{count} )',
  },
  productDiscounts: {
    id: 'Thankyou.ThankyouSummary.productDiscounts',
    description: 'Order Summary Product Discounts label',
    defaultMessage: 'Discounts Applied',
  },
  promos: {
    id: 'Thankyou.ThankyouSummary.promos',
    description: 'Order Summary promos label',
    defaultMessage: 'Promos',
  },
  giftCards: {
    id: 'Thankyou.ThankyouSummary.giftCards',
    description: 'Order Summary giftCards label',
    defaultMessage: `Gift Cards {count, plural,
      =0 {}
      other {({count})}
    }`,
  },
  shippingCost: {
    id: 'Thankyou.ThankyouSummary.shippingCost',
    description: 'Order Summary shipping cost label',
    defaultMessage: 'Shipping Cost',
  },
  qualifiedFreeWhiteGloveShipping: {
    id: 'Thankyou.ThankyouSummary.qualifiedFreeWhiteGloveShipping',
    description: 'Order Summary qualified for whithe glove free shipping label',
    defaultMessage: '* You’ve qualified for FREE white glove shipping!',
  },
  taxes: {
    id: 'Thankyou.ThankyouSummary.taxes',
    description: 'Order Summary taxes label',
    defaultMessage: 'Taxes',
  },
  recyclingFee: {
    id: 'Thankyou.ThankyouSummary.recyclingFee',
    description: 'Order Summary recycling fee',
    defaultMessage: 'Recycling Fee',
  },
  deliveryFee: {
    id: 'Thankyou.ThankyouSummary.deliveryFee',
    description: 'Order Summary delivery fee',
    defaultMessage: 'Delivery Fee',
  },
  total: {
    id: 'Thankyou.ThankyouSummary.total',
    description: 'Order Summary total label',
    defaultMessage: 'Order Total',
  },
  billingAndDelivery: {
    id: 'Thankyou.ThankyouSummary.billingAndDelivery',
    description: 'Order Summary Billing and Delivery title',
    defaultMessage: 'Billing & Delivery',
  },
  billing: {
    id: 'Thankyou.ThankyouSummary.billing',
    description: 'Order Summary billing title',
    defaultMessage: 'Billing Address',
  },
  paymentMethod: {
    id: 'Thankyou.ThankyouSummary.paymentMethod',
    description: 'Order Summary Payment Method title',
    defaultMessage: 'Payment Method',
  },
  delivery: {
    id: 'Thankyou.ThankyouSummary.delivery',
    description: 'Order Summary delivery title',
    defaultMessage: 'Delivery Address',
  },
  deliveryMethod: {
    id: 'Thankyou.ThankyouSummary.deliveryMethod',
    description: 'Order Summary Delivery Method title',
    defaultMessage: 'Delivery Method',
  },
  mattressRemoval: {
    id: 'Thankyou.ThankyouSummary.mattressRemoval',
    description: 'Order Summary mattress removal',
    defaultMessage: 'Mattress Removal',
  },
  warranties: {
    id: 'Thankyou.ThankyouSummary.warranties',
    description: 'Order Summary Warranties label',
    defaultMessage: 'Warranties',
  },
  beddingPromoTitle: {
    id: 'Thankyou.ThankyouSummary.beddingPromo.title',
    description: 'Message for the price breakdown products discounts title',
    defaultMessage: `Bedding Promo {remaining,plural,
      =0 {}
      other {({remaining} Remaining)}
    }`,
  },
  affirmTitle: {
    id: 'Thankyou.ThankyouSummary.affirm',
    defaultMessage: 'Affirm',
  },
  chargeAfterTitle: {
    id: 'Thankyou.ThankyouSummary.chargeAfterTitle',
    defaultMessage: 'Purple Financing',
  },
  paypalTitle: {
    id: 'Thankyou.ThankyouSummary.paypal',
    defaultMessage: 'PayPal',
  },
  shopPayTitle: {
    id: 'Thankyou.ThankyouSummary.shopPay',
    defaultMessage: 'Shop Pay',
  },
  visaCardBrandText: {
    id: 'Thankyou.ThankyouSummary.visaCardBrandText',
    defaultMessage: 'VISA',
  },
  mastercardCardBrandText: {
    id: 'Thankyou.ThankyouSummary.mastercardCardBrandText',
    defaultMessage: 'MC',
  },
  americanExpressCardBrandText: {
    id: 'Thankyou.ThankyouSummary.americanExpressCardBrandText',
    defaultMessage: 'AMEX',
  },
  americanExpressLogoText: {
    id: 'Thankyou.ThankyouSummary.americanExpressLogoText',
    defaultMessage: 'american-express',
  },
  discoverCardBrandText: {
    id: 'Thankyou.ThankyouSummary.discoverCardBrandText',
    defaultMessage: 'DISCOVER',
  },
});
